import { Pipe, PipeTransform } from '@angular/core'
import { FieldMapping } from '../models/ticket.model'

@Pipe({ name: 'fieldMapping' })
export class FieldMappingPipe implements PipeTransform {
  transform(value: any): string {
    return FieldMapping[value]
  }
}
